import { apiFetch } from '../auth/apiFetch.ts';
import { useQuery } from '@tanstack/react-query';
import type { RobotStatus } from './useRobots.ts';

// Fleet summary — backs the dashboard MetricCards.
// Shape mirrors api/routers/stats.py.
export interface Stats {
  total_robots: number;
  active_robots: number;
  avg_battery_pct: number | null;
  status_counts: Partial<Record<RobotStatus, number>>;
  pending_commands: number;
  /* Null whenever the deployment's telemetry backend is not Postgres — the
     AWS API runs TELEMETRY_BACKEND=dynamodb and stats.py leaves the 24 h count
     unset there (the analytical query belongs in the time-series store, and is
     not wired yet). The field is a figure the API may not have, so it is typed
     as one. */
  telemetry_last_24h: number | null;
}

async function fetchStats(): Promise<Stats> {
  const r = await apiFetch('/api/stats');
  if (!r.ok) throw new Error(`status ${r.status}`);
  return (await r.json()) as Stats;
}

export function useStats() {
  return useQuery({
    queryKey: ['stats'] as const,
    queryFn: fetchStats,
    refetchInterval: 5_000,
  });
}
